import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['StoreManager']['getToyHistory']
type inputType = RouterInputs['StoreManager']['getToyHistory']

export const useGetToyHistory = (input: inputType, options?: optionsType) =>
    api.StoreManager.getToyHistory.useQuery(input, {
        ...options,
        queryKey: ['StoreManager.getToyHistory', input],
        // TODO 15-минутный стейл тайм на время релиза
        staleTime: 15 * 60 * 1000 * staleTimeIndex, // 15 mins
    })
